import { useMemo } from 'react'

import { type CoreItemCategory } from '@flecto/types'

import { useFlattenItemCategories } from '../../../categories/hooks/useFlattenItemCategories'

export const useCategoryMoving = (item?: CoreItemCategory) => {
  const { categories: flatCategories = [] } = useFlattenItemCategories()

  return useMemo(() => {
    const categoriesOrder = flatCategories
      .filter((category) => !category.parent_id)
      .map((category) => category.order)
      .sort((a, b) => a - b)

    const subcategoriesOrder = flatCategories
      .filter((category) => category.parent_id === item?.parent_id)
      .map((category) => category.order)
      .sort((a, b) => a - b)

    const shouldDisableMoveUpButton =
      (item?.order === categoriesOrder[0] && !item?.parent_id) ||
      (!!item?.parent_id && item?.order === subcategoriesOrder[0])

    const shouldDisableMoveDownButton =
      (item?.order === categoriesOrder[categoriesOrder.length - 1] &&
        !item?.parent_id) ||
      (!!item?.parent_id &&
        item?.order === subcategoriesOrder[subcategoriesOrder.length - 1])

    return {
      shouldDisableMoveUpButton,
      shouldDisableMoveDownButton,
    }
  }, [flatCategories, item?.parent_id, item?.order])
}
